import {
  getMessageVersions,
  hasMessageText,
  type DataItem,
} from '../../../../utils/interface-types';

export type GrigoExternalChatMessage = {
  id: string;
  role: 'user' | 'assistant';
  content: string;
};

function humanMessageText(message: DataItem['message']): string {
  if (message == null) return '';
  if (Array.isArray(message)) {
    return message.filter((part): part is string => typeof part === 'string').join('\n');
  }
  return typeof message === 'string' ? message : '';
}

/**
 * Maps Grigo chat history into a flat user/assistant list for assistant-ui ExternalStoreRuntime.
 */
export function mapGrigoChatHistoryToExternalMessages(
  chatHistory: DataItem[],
): GrigoExternalChatMessage[] {
  const out: GrigoExternalChatMessage[] = [];

  chatHistory.forEach((item, index) => {
    if (item.role === 'Human') {
      const content = humanMessageText(item.message).trim();
      if (!content) return;
      out.push({ id: `grigo-human-${index}`, role: 'user', content });
      return;
    }

    if (item.role === 'AI') {
      const versions = getMessageVersions(item.message);
      const versionIndex = Math.max(versions.length - 1, 0);
      const content = (versions[versionIndex] ?? '').trim();
      if (!content && !item.isStreaming && !item.isThinking) return;
      out.push({
        id: `grigo-ai-${index}`,
        role: 'assistant',
        content: content || (item.isStreaming ? '…' : ''),
      });
    }
  });

  return out;
}

export function grigoChatHistoryHasDisplayableMessages(chatHistory: DataItem[]): boolean {
  return chatHistory.some(
    (item) =>
      (item.role === 'Human' && hasMessageText(item.message)) ||
      (item.role === 'AI' &&
        (hasMessageText(item.message) || item.isStreaming === true || item.isThinking === true)),
  );
}
